import { liveShareTouch, shareChannelFromSearch, type ShareChannel, type StoredShareTouch } from "@shared/share";

/**
 * The app the last shared link this browser opened came through (`sh=<channel>`),
 * kept a week so the order is credited to it even when the buyer comes back
 * later. The newest shared link wins.
 */
const KEY = "shz_share_touch";

/** This page load's own, in case storage loses it before checkout. */
let captured: StoredShareTouch | null = null;

/** Call at bootstrap, while the landing address still carries `sh`. */
export function captureShareFromUrl(): void {
  const ch = shareChannelFromSearch(window.location.search);
  if (!ch) return;
  captured = { ch, at: Date.now() };
  try {
    window.localStorage.setItem(KEY, JSON.stringify(captured));
  } catch {
    // storage blocked: this page load still credits its own link from memory
  }
}

function stored(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

/** The channel to post with an order: this address's own, else the kept one. */
export function shareForOrder(): { share?: ShareChannel } {
  const now = Date.now();
  const own = shareChannelFromSearch(window.location.search);
  const ch = own ?? liveShareTouch(stored(), now) ?? (captured ? liveShareTouch(JSON.stringify(captured), now) : null);
  return ch ? { share: ch } : {};
}
